/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../helpers'
import {Lang, useLang, useSetLang} from '../../../i18n/Metronici18n'
import Select, {components} from 'react-select'
import './Languages.scss'

const languages = [
  {
    lang: 'en',
    name: 'English',
    flag: toAbsoluteUrl('/media/flags/united-states.svg'),
  },
  {
    lang: 'sv',
    name: 'Swedish',
    flag: toAbsoluteUrl('/media/flags/sweden.svg'),
  },
  {
    lang: 'fin',
    name: 'Finnish',
    flag: toAbsoluteUrl('/media/flags/finland.svg'),
  },
  {
    lang: 'no',
    name: 'Norwegian',
    flag: toAbsoluteUrl('/media/flags/norway.svg'),
  },
  // {
  //   lang: 'es',
  //   name: 'Spanish',
  //   flag: toAbsoluteUrl('/media/flags/spain.svg'),
  // },
  // {
  //   lang: 'ja',
  //   name: 'Japanese',
  //   flag: toAbsoluteUrl('/media/flags/japan.svg'),
  // },
  // {
  //   lang: 'de',
  //   name: 'German',
  //   flag: toAbsoluteUrl('/media/flags/germany.svg'),
  // },
  // {
  //   lang: 'fr',
  //   name: 'French',
  //   flag: toAbsoluteUrl('/media/flags/france.svg'),
  // },
]
const Option = (props: any) => (
  <components.Option {...props}>
    <span>
      <img src={props.data.flag} alt={props.data.name} className='w-20px h-20px rounded-1' />
      <span>{props.data.name}</span>
    </span>
  </components.Option>
)

const SingleValue = (props: any) => (
  <components.SingleValue {...props}>
    <span className='d-flex align-items-center gap-2'>
      <img src={props.data.flag} alt={props.data.name} className='w-15px h-15px rounded-1' />
      {props.data.name}
    </span>
  </components.SingleValue>
)

const Languages: FC = () => {
  const lang = useLang()
  const setLang = useSetLang()
  const currentLang = languages.find((l) => l.lang === lang) || languages[0]

  return (
    <div className='menu-item'>
      <Select
        classNamePrefix='pg-select'
        className='react-select-pg language'
        value={currentLang}
        onChange={(selected) => setLang(selected?.lang as Lang)}
        options={languages}
        getOptionLabel={(opt) => opt.name}
        getOptionValue={(opt) => opt.lang}
        components={{
          Option,
          SingleValue,
          IndicatorSeparator: () => null,
        }}
        styles={{
          option: (base, {isFocused, isSelected}) => ({
            ...base,
            backgroundColor: isSelected ? '#F5F8FA' : isFocused ? '#F5F8FA' : '',
            color: isSelected ? '#009EF7' : isFocused ? '#009EF7' : '',
          }),
        }}
        isSearchable={false}
      />
    </div>
  )
}

export {Languages}
